import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import {
    Link
} from 'react-router-dom';

import * as actions from '../../actions/actions.jsx'
import { connect } from "react-redux";
import Loader from '../loader/loader.jsx'

import '../../stylesheet/cardsummary.css'

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState,
    display: state.getCardReducer.display
})

const mapDispatchToProps = dispatch =>
({
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    }
})
const JSEncrypt = window.JSEncrypt
class Summary extends Component {

    componentDidMount() {
        const { publicKey } = this.props
        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);

                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);
    }

    render() {
        const { cardState } = this.props
        return (
            <div>
                <div className="row" >
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>
                    <div className="container" style={{ marginTop: "80px" }}>
                        <div className="row">
                            <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                <LeftLink />
                            </div>
                            <div className="col-sm-9" style={{ padding: "0px 30px", minHeight: "470px" }} >
                                <div className="row box-shadow-style" style={{ padding: "12px 0px" }}>

                                    <div className="col-md-12" >
                                        <div>
                                            <h4>My Card Activity </h4>
                                        </div>
                                        {cardState.status === 200 ? cardState.body.map((value, i) =>
                                            <div className="summary-content" key={i}>
                                                <div className="summary-body">
                                                    <div className="summary-header">
                                                        <div className="row" style={{ marginBottom: "13px" }}>
                                                            <div className="col-md-6">
                                                                {cardState.body[i].cardProgramId}<span>{cardState.body[i].cardNumber}</span>
                                                            </div>
                                                            <div className="col-md-6 text-right">
                                                                <Link to={{ pathname: '/card-activity', state: cardState.body[i].cardDetailsId }}
                                                                >Click here to view card activity</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tile box-shadow-style">
                                                        <div className="row">
                                                            <div className="col-md-5 col-sm-12">
                                                                <div className="row">
                                                                    <div className="col-md-5  tilepadding">
                                                                        <label className="tilecontent">Account Name </label>
                                                                    </div>
                                                                    <div className="col-md-6 text-left tilepadding">
                                                                        <span className="tileheadername"> {cardState.body[i].firstName + " " + cardState.body[i].lastName || "NA"} </span><br />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-5  tilepadding">
                                                                        <label className="tilecontent">Available Balance </label>
                                                                    </div>
                                                                    <div className="col-md-6 text-left tilepadding">
                                                                        <span className="tileheadername"> {cardState.body[i].availableBalance || "NA"}  </span><br />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-5  tilepadding">
                                                                        <label className="tilecontent">Card Status  </label>
                                                                    </div>
                                                                    <div className="col-md-7 text-left tilepadding">
                                                                        <span className="tileheadername"> {cardState.body[i].cardStatus || "NA"} </span><br />
                                                                    </div>
                                                                </div>
                                                                {/* <div className="row">
                                                                    <div className="col-md-5  tilepadding">
                                                                        <label className="tilecontent">Last Statement Closing Balance </label>
                                                                    </div>
                                                                    <div className="col-md-7 text-left tilepadding">
                                                                        <span className="tileheadername"> : {cardState.body[i].lastStatementClosingBalance || "NA"}  </span><br />
                                                                    </div>
                                                                </div>
                                                               
                                                                <div className="row">
                                                                    <div className="col-md-5  tilepadding">
                                                                        <label className="tilecontent">Last Debit Posted </label>
                                                                    </div>
                                                                    <div className="col-md-6 text-left tilepadding">
                                                                        <span className="tileheadername"> : {cardState.body[i].lastDebitPosted || "NA"}  </span><br />
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                            <div className="col-md-7 col-sm-12">
                                                                <div className="row">
                                                                    <div className="col-md-5  tilepadding">
                                                                        <label className="tilecontent">Ledger Balance </label>
                                                                    </div>
                                                                    <div className="col-md-7 text-left tilepadding">
                                                                        <span className="tileheadername">  {cardState.body[i].ledgerBalance || "NA"}  </span><br />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-5  tilepadding">
                                                                        <label className="tilecontent">Last Credit Posted </label>
                                                                    </div>
                                                                    <div className="col-md-6 text-left tilepadding">
                                                                        <span className="tileheadername"> {cardState.body[i].lastCreditPosted || "NA"} </span><br />
                                                                    </div>
                                                                </div>



                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) :
                                            <div style={{ width: "100%" }}><Loader /></div>
                                        }

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
Summary.defaultProps = {
    cardState: {
        status: 400
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
// export default Summary;


// WEBPACK FOOTER //
// ./src/components/cardsummary/summary.jsx